// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__4uYEE","info":"Panel_info__03IrK","btns":"Panel_btns__zVySU","button":"Panel_button__mC8Cn"};